import Vue from 'vue'
import AppState from '@/plugins/appstate'

Vue.filter('ticketState', (code) => {
  switch (code) {
    case 0: return AppState.App ? AppState.App.$t('at.requested') : 'at.requested'
    case 1: return AppState.App ? AppState.App.$t('at.re-requested') : 'at.re-requested'
    case 2: return AppState.App ? AppState.App.$t('at.approved') : 'at.approved'
    case 3: return AppState.App ? AppState.App.$t('at.on-work') : 'at.on-work'
    case 4: return AppState.App ? AppState.App.$t('at.reject') : 'at.reject'
    case 10: return AppState.App ? AppState.App.$t('at.completed') : 'at.completed'
    default: return AppState.App ? AppState.App.$t('at.Unknown') : 'at.Unknown'
  }
})

Vue.filter('alertName', (code, key) => {
  const matched = code.match(/I([A-Z])(\d+)/)
  let resp = {
    label: 'Unknown',
    os: 'Unknown'
  }
  if (matched && matched.length >= 3) {
    resp.os = matched[1]
    const type = parseInt(matched[2], 10)
    switch (type) {
      case 1: resp.label = 'Disconnected'; break
      case 2: resp.label = 'CPU Usage'; break
      case 3: resp.label = 'Memory Usage'; break
      case 4: resp.label = 'Disk Usage'; break
      case 5: resp.label = 'CPU Temperature'; break
      case 6: resp.label = 'Disk Temperature'; break
      case 7: resp.label = 'Fan Speed'; break
      default: resp.label = 'Unknown'
    }
  }

  if (key && (key === 'label' || key === 'os')) return resp[key]
  return resp
})

Vue.filter('nameOS', code => {
  let id = parseInt(code, 10)
  if (!id) return 'question-circle'
  switch (id) {
    case 1: return 'brands/windows'
    case 2: return 'brands/linux'
    case 3: return 'brands/apple'
    case 4: return 'brands/android'
    case 5: return 'brands/apple'
    default: return 'question-circle'
  }
})

Vue.filter('remoteOS', code => {
  let id = parseInt(code, 10)
  if (!id) return 'question-circle'
  switch (id) {
    case 1: return 'Windows'
    case 2: return 'Linux'
    case 3: return 'MacOS'
    case 4: return 'Android'
    case 5: return 'iOS'
    default: return 'Unknown'
  }
})

const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']

Vue.filter('convBitSize', bytes => {
  if (bytes === 0) return 'n/a'
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
  if (i === 0) return `${bytes} ${sizes[i]}`
  return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
})

Vue.filter('comma', n => {
  if (typeof n !== 'number') return n
  var parts = n.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
})
